/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const BulkBox = styled.div`
  background: ${Palette.PrimaryGray._100};
  padding: 8px 16px;
  border-top: 1px solid ${Palette.PrimaryGray._200};
  z-index: 400;
  position: relative;
  gap: 10px;
  align-items: center;
  /* overflow: hidden; */
  ${({ isActive }) =>
    isActive
      ? css`
          display: flex;
        `
      : css`
          display: none;
        `}
`;

export const Box = styled.div`
  margin-left: ${({ isLastBtn }) => isLastBtn && 'auto'};
`;
